<div
  #chartBoxEcharts
  echarts
  [initOpts]="localInitOpts"
  [options]="localOptions"
  (chartInit)="onChartInit($event)"
  class="my-echarts overflow-hidden"
  style="width: 100%; height: 100%"
></div>
